import { useMsalAuthentication } from "@azure/msal-react";

function useAuthState() {
    const { result } = useMsalAuthentication();

    const getStateObject = () => {
        let stateObject = null;
        try {
            let stateResult = result?.state ? result.state : null;
            stateObject = JSON.parse(stateResult);
        } catch (e) {
            stateObject = null;
        }
        return typeof stateObject === 'object' ? stateObject : null;
    }

    const getRole = () => {
        return getStateObject()?.userRole
            ? getStateObject()?.userRole
            : null;
    }

    return {
        getStateObject,
        getRole
    };
}

export default useAuthState;
